import React, { useEffect, useState } from "react";
import GitHubIcon from "@material-ui/icons/GitHub";
import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import TwitterIcon from "@material-ui/icons/Twitter";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import Fab from "@material-ui/core/Fab";
import anime from "animejs";
import "../../../plugin/landingPage/base.css";
import "../../../plugin/landingPage/baseAnimation.css";
import "hover.css";
import SocialIcon from "../socialIcon";
import AutoRotatingCarouselModal from "./introduceCarousel";

const LandingPage = () => {
  let animation = () => {
    anime
      .timeline({ loop: true })
      .add({
        targets: ".ml10 .letter",
        rotateY: [-90, 0],
        duration: 1300,
        delay: (el, i) => 45 * i,
      })
      .add({
        targets: ".ml10",
        opacity: 0,
        duration: 1000,
        easing: "easeOutExpo",
        delay: 1000,
      });
  };
  const [handleOpen, setHandleOpen] = useState({ open: false });
  const handleClick = () => {
    setHandleOpen({ open: true });
    window.location = "#about";
  };
  const matches = window.matchMedia("(max-width: 600px)");

  let socialLink = [
    {
      label: "github",
      href: "https://github.com/guptaashwanee",
      icon: GitHubIcon,
    },
    {
      label: "linkedin",
      href: "https://www.linkedin.com/in/guptaashwanee/",
      icon: LinkedInIcon,
    },
    {
      label: "twitter",
      href: "https://twitter.com/guptaashwanee",
      icon: TwitterIcon,
    },
    {
      label: "facebook",
      href: "https://www.facebook.com/guptaashwanee",
      icon: FacebookIcon,
    },
    {
      label: "instagram",
      href: "https://www.instagram.com/guptaashwanee/",
      icon: InstagramIcon,
    },
  ];

  useEffect(() => {
    animation();
  }, []);
  let contentDescription =
    "We create beautiful Graphics, Functional website, Visual effects";
  return (
    <div className="landingPage imgloaded">
      <div className="content_home">
        <div className="glitch">
          <div className="glitch__img"></div>
          <div className="glitch__img"></div>
          <div className="glitch__img"></div>
          <div className="glitch__img"></div>
          <div className="glitch__img"></div>
        </div>
        <div>
          <h2 className="content__title text-white text-center ">Inspire</h2>
          <h2 className="ml10 text-white content_description p-3">
            <span className="text-wrapper">
              <span className="letters">
                {contentDescription.split(" ").map((word, index) => (
                  <div className="d-inline-block px-1" key={word + index}>
                    {word.split("").map((letter, index) => (
                      <span key={letter + index} className="letter">
                        {letter}
                      </span>
                    ))}
                  </div>
                ))}
              </span>
            </span>
          </h2>
        </div>
        <p className="content__text">
          Evening was in the wood, louring with storm. A time of drought had
          sucked the weedy pool and baked the channels; birds had done with
          song.
        </p>
        <div className="content__btn hvr-icon-wobble-vertical">
          <Fab
            onClick={handleClick}
            href="#about"
            variant="extended"
            aria-label="getStarted"
          >
            Get Started
            <i
              className="fa fa-arrow-down pl-2 hvr-icon"
              aria-hidden="true"
            ></i>
          </Fab>
        </div>
        <SocialIcon content={socialLink}></SocialIcon>
      </div>
      <AutoRotatingCarouselModal
        isMobile={matches.matches}
        handleOpen={handleOpen}
        setHandleOpen={setHandleOpen}
      />
    </div>
  );
};

export default LandingPage;
